<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="d-flex align-items-center justify-content-between">
      <PageTitle title="Enviar notificações para o aplicativo" />
    </b-col>

    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Notificações criadas</h3>
      <b-button
        pill
        variant="success"
        @click="$refs.newNotificationModal.toggleOpen(dadosUsuario.id)"
      >
        <i class="fas fa-plus-circle mr-2"></i>
        Criar notificação
      </b-button>
    </b-col>
    
    <b-col cols="12" class="mt-2">
      <b-table
        striped
        responsive
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #cell(date_send)="data">    
         {{ formatDate(data.item.date_send) }}
        </template>

        <template #cell(actions)="data">    
          <b-button
            @click="$refs.detailNotificationModal.toggleOpen({data: data.item})"
            class="mr-2"
            variant="warning"
            size="sm"
            title="Detalhes da notificação"
          >
            <i class="fas fa-eye"></i>
          </b-button>

          <b-button
            @click="$refs.deleteNotificationModal.toggleOpen({id: data.item.id})"
            variant="danger"
            size="sm"
            title="Excluir notificação"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
    
    <NewNotificationModal 
      ref="newNotificationModal"
      @send="sendNotification($event)"
    />
    <DeleteNotificationModal 
      ref="deleteNotificationModal" 
      @delete="deleteNotification($event)"

    />
    <DetailNotificationModal 
      ref="detailNotificationModal"
      @update="detailNotification($event)"
    />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import NewNotificationModal from '@/components/Notification/NewNotificationModal.vue';
import DeleteNotificationModal from '@/components/Notification/DeleteNotificationModal.vue';
import DetailNotificationModal from '@/components/Notification/DetailNotificationModal.vue';

export default {
  name: 'NotificationsAppCms',
  mixins: [makeToast],

  components: {
    PageTitle,
    NewNotificationModal,
    DeleteNotificationModal,
    DetailNotificationModal,
  },

  data() {
    return {
      loading: false,
      limpar: false,
      table: {
        headers: [
          {
            key: 'title',
            label: 'Titulo',
          },
          {
            key: 'text',
            label: 'Mensagem',
          },
          {
            key: 'date_send',
            label: 'Data de envio',
          },
          {
            key: 'actions',
            label: 'Ações',
          },
        ], 
        records: [],
      }
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.getNotification();
  },

  methods: {
    ...mapActions('shopkeeper', [
      'getNotificationAppCms',
      'sendNotificationAppCms',
      'deleteNotificationAppCms',
    ]),
    
    getNotification() {
      this.loading = true;

      this.getNotificationAppCms(this.dadosUsuario.id)
        .then((response) => {
          this.table.records = response.data.data || [];
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as notificações',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    sendNotification(data) {
      this.sendNotificationAppCms(data)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Notificação enviada com sucesso',
            'success'
          );
          this.getNotification();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao enviar a notificação',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteNotification(data) {
      this.deleteNotificationAppCms(data.id)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Notificação apagada com sucesso',
            'success'
          );
          this.getNotification();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao deletar a notificação',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date) {
      const options = {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: 'America/Sao_Paulo' // Set Brazilian time zone
      };
      return new Date(date).toLocaleDateString('pt-BR', options);
    },
  },
};
</script>